module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "max-width": "640px",
      "margin": "0 auto"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeLogoutNotification()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #87B0C4",
      "padding-top": "1em",
      "opacity": "0.7",
      "font-size": "90%"
    }
  }, [_c('b-icon-lock-fill', {
    staticStyle: {
      "float": "left",
      "font-size": "32px",
      "width": "46px",
      "opacity": "0.5",
      "margin": "2px 0 40px 0"
    }
  }, [_vm._v(" ")]), _vm._v("\n            Security Notice:\n            XMission will "), _c('b', [_vm._v("never")]), _vm._v(" contact you to ask for your password, account or other personal information. If you receive any request of this nature, please contact us immediately at 801-539-0852 or "), _c('a', {
    attrs: {
      "href": "mailto:support@xmission.com"
    }
  }, [_vm._v("support@xmission.com")]), _vm._v(".\n      ")], 1)]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('span', [_vm._v("\n            Logout complete\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b9bda70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoutNotification.vue
// module id = 1577
// module chunks = 5